import React from 'react';
import { Checkbox } from 'semantic-ui-react'

class Title extends React.Component {

  state = {

  }

  handleChange = name => (e, { checked }) => {
    this.props.update(name, checked, this.props.menuid)
  };

  render() {
    let tag = (<tbody></tbody>);
    if (this.props.menu == 'purchaser') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Purchaser</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'purchaserview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                            <Checkbox onClick={this.handleChange('purchaserview')}
                              defaultChecked={v.view}
                              style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'purchaseredit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('purchaseredit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'accounting') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Accounting</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'transfercontrol') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Transfer</div>
                        <div style={{marginRight: 1}}>
                      <Checkbox onClick={this.handleChange('transfercontrol')} defaultChecked={v.view}
                                style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'purchase-request') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Temp Req.</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'temprequest') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('temprequest')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Add Req.</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'addrequest') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('addrequest')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Pending Req.</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'pendingrequestview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('pendingrequestview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'pendingrequestedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('pendingrequestedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'pendingrequestexport') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Export</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('pendingrequestexport')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
          <center>
          <b>Purchase From</b><br/>
          { this.props.submenus.map((v) => {
              if (v.submenuname == 'purchasefrompurchaser') {
                return (
                  <div style={{display: 'flex'}}>
                    <div style={{width: 50}}>Purchaser</div>
                    <div style={{marginRight: 1}}>
                      <Checkbox onClick={this.handleChange('purchasefrompurchaser')}
                       defaultChecked={v.view}
                      style={{marginLeft: '10%', backgroundColor: 'red'}} />
                    </div>
                  </div>
                );
              }
              else if (v.submenuname == 'purchasefrombranch') {
                return (
                  <div style={{display: 'flex'}}>
                    <div style={{width: 50}}>Branch</div>
                    <div style={{marginRight: 1}}>
                      <Checkbox onClick={this.handleChange('purchasefrombranch')}
                        defaultChecked={v.view}
                        style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                    </div>
                  </div>
                );
              }
            })
          }
          </center>
          </td><td></td><td></td><td></td><td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'price-menu') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Price Menu</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'pricediscountview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('pricediscountview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'pricediscountedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('pricediscountedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'parts') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Parts</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'partsview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('partsview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'partsedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('partsedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                          </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'partsexport') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Export</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('partsexport')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                          </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'upi-details') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Upi</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'upiview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('upiview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'upiedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('upiedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'invoice') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Invoice</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'invoiceview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('invoiceview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'invoiceedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('invoiceedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'invoicecancel') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Cancel</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('invoicecancel')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'edit-menu') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Edit Menu</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'editmenuview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('editmenuview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'editmenuedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('editmenuedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'editmenuexport') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Export</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('editmenuexport')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'executive-branch') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Exe Branch</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'executivebranchview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('executivebranchview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'executivebranchedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('executivebranchedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'add-menu') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Branch</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'branchview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('branchview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'branchedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('branchedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Model</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'modelview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('modelview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'modeledit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('modeledit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Assembly</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'assemblyview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('assemblyview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'assemblyedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('assemblyedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Group</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'groupview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('groupview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'groupedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('groupedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Category</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'categoryview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('categoryview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'categoryedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('categoryedit')}
                              defaultChecked={v.view}
                              style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Brand</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'brandview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('brandview')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>

                    );
                  }
                  else if (v.submenuname == 'brandedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('brandedit')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>

                    );
                  }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Combo</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'comboview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('comboview')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>

                    );
                  }
                  // else if (v.submenuname == 'comboedit') {
                  //   return (
                  //     <Checkbox onClick={this.handleChange('comboedit')} defaultChecked={v.view}
                  //               style={{marginLeft: '10%', backgroundColor: 'blue', dispaly: 'none'}} />
                  //   );
                  // }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Mode</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'modeview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('modeview')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>

                    );
                  }
                  else if (v.submenuname == 'modeedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('modeedit')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>

                    );
                  }
                })
              }
            </center>
          </td>
        </tr>
      )
    }
    else if (this.props.menu == 'menu-control') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Menu Control</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'menucontrolview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('menucontrolview')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>

                    );
                  }
                  else if (v.submenuname == 'menucontroledit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('menucontroledit')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>

                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'bank-details') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Bank</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'bankview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('bankview')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>

                    );
                  }
                  else if (v.submenuname == 'bankedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('bankedit')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>

                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'add-customer') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Add Cust.</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'addcustomerview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('addcustomerview')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'addcustomeredit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('addcustomeredit')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'addcustomerexport') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Export</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('addcustomerexport')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'stock-audit') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Stock Audit</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'stockauditview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('stockauditview')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'stockauditedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('stockauditedit')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'stockauditexport') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Export</div>
                        <div style={{marginRight: 1}}>
                        <Checkbox onClick={this.handleChange('stockauditexport')} defaultChecked={v.view}
                                  style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'receipt') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Receipt</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'receiptview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('receiptview')} defaultChecked={v.view}
                                    style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'receiptedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('receiptedit')} defaultChecked={v.view}
                                    style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'receiptexport') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Export</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('receiptexport')} defaultChecked={v.view}
                                    style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'tickets') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Ticket</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'ticketedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('ticketedit')} defaultChecked={v.view}
                                    style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'quotation') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Quotation</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'quotationview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('quotationview')}
                                    defaultChecked={v.view}
                                    style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'quotationedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('quotationedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'quotationexport') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Export</div>
                        <div style={{marginRight: 1}}>
                            <Checkbox onClick={this.handleChange('quotationexport')}
                              defaultChecked={v.view}
                              style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'quotationcancel') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Cancel</div>
                        <div style={{marginRight: 1}}>
                            <Checkbox onClick={this.handleChange('quotationcancel')}
                              defaultChecked={v.view}
                              style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'stock-info') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Info</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'stockinfo') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('stockinfo')} defaultChecked={v.view}
                                    style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'stockinfoexport') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Export</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('stockinfoexport')} defaultChecked={v.view}
                                    style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'statement') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Statement</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'statementview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                      <Checkbox onClick={this.handleChange('statementview')} defaultChecked={v.view}
                                style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'sms') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Single</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'singlesms') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                      <Checkbox onClick={this.handleChange('singlesms')} defaultChecked={v.view}
                                style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Bulk</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'bulksms') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                      <Checkbox onClick={this.handleChange('bulksms')} defaultChecked={v.view}
                                style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Report</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'smsreport') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                      <Checkbox onClick={this.handleChange('smsreport')} defaultChecked={v.view}
                                style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'machineinfo') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>machine Info</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'machineinfoview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                      <Checkbox onClick={this.handleChange('machineinfoview')} defaultChecked={v.view}
                                style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'machineinfoedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                      <Checkbox onClick={this.handleChange('machineinfoedit')} defaultChecked={v.view}
                                style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'machinecustomer') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>machine Customer Add</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'machinecustomerview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                      <Checkbox onClick={this.handleChange('machinecustomerview')} defaultChecked={v.view}
                                style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'machinecustomeredit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('machinecustomeredit')} defaultChecked={v.view}
                                    style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'machinecustomerexport') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Export</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('machinecustomerexport')} defaultChecked={v.view}
                                    style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'machinesales') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Sales</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'machinesalesview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('machinesalesview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'machinesalesedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('machinesalesedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'analytics') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>View</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'analyticsview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('analyticsview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
          <center>
          <b>Export</b><br/>
          { this.props.submenus.map((v) => {
              if (v.submenuname == 'analyticsexport') {
                return (
                  <div style={{display: 'flex'}}>
                    <div style={{marginRight: 1}}>
                      <Checkbox onClick={this.handleChange('analyticsexport')}
                        defaultChecked={v.view}
                        style={{marginLeft: '10%', backgroundColor: 'red'}} />
                    </div>
                  </div>
                );
              }
            })
          }
          </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'stock-transfer') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Stock In</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'stockinview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('stockinview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'stockinedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('stockinedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Stock Out</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'stockoutview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('stockoutview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'stockoutedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('stockoutedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Stock Transfer</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'stocktransferedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('stocktransferedit')}
                           defaultChecked={v.view}
                           style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td>
            <center>
              <b>Shortage</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'shortageview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('shortageview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'shortageedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('shortageedit')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'offers') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Offers</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'offerview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('offerview')}
                            defaultChecked={v.view}
                            style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'offeredit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('offeredit')}
                           defaultChecked={v.view}
                           style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'place-order') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Add Placeorder</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'placeorderview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('placeorderview')}
                           defaultChecked={v.view}
                           style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                  if (v.submenuname == 'placeorderedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('placeorderedit')}
                           defaultChecked={v.view}
                           style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
        </tr>
      )
    }
    else if (this.props.menu == 'purchase-details') {
      tag = (
        <tr>
          <td><center>{this.props.menu}</center></td>
          <td>
            <center>
              <b>Purchase Details</b><br/>
              { this.props.submenus.map((v) => {
                  if (v.submenuname == 'purchasedetailsview') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>View</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('purchasedetailsview')}
                           defaultChecked={v.view} style={{marginLeft: '10%', backgroundColor: 'red'}} />
                        </div>
                      </div>
                    );
                  }
                  else if (v.submenuname == 'purchasedetailsedit') {
                    return (
                      <div style={{display: 'flex'}}>
                        <div style={{width: 50}}>Edit</div>
                        <div style={{marginRight: 1}}>
                          <Checkbox onClick={this.handleChange('purchasedetailsedit')}
                            defaultChecked={v.view} style={{marginLeft: '10%', backgroundColor: 'blue'}} />
                        </div>
                      </div>
                    );
                  }
                })
              }
            </center>
          </td>
          <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
        </tr>
      )
    }
    return (
      <tbody>
        {tag}
      </tbody>
    );
  }
}

export default Title;
